@if (paymentSessionExpired$ | async) {
  <gb-payment-expired></gb-payment-expired>
} @else {
  @if ({ selectedStepIndex: selectedStepIndex$ | async }; as obs) {
    <div class="gb-event-ticket-purchase-dialog">
      <div class="gb-dialog-header">
        <h1 translate="EVENT_TICKET_PACKAGES.PURCHASE.TITLE"></h1>

        <button
          mat-button
          class="close-button"
          (click)="onCancel()"
          [disabled]="(placePurchaseLoaded$ | async) === false"
        >
          <gb-icon icon="close" [library]="IconLibrary.material"></gb-icon>
        </button>
      </div>

      <mat-stepper
        #purchaseStepper
        [linear]="true"
        [selectedIndex]="obs.selectedStepIndex"
        labelPosition="bottom"
        animationDuration="0ms"
        (selectionChange)="onStepChange($event)"
      >
        <mat-step [label]="'EVENT_TICKET_PACKAGES.PURCHASE.STEP_LABEL_GUEST' | translate" [editable]="false">
          <gb-event-ticket-purchase-guest (stepComplete)="onGuestStepComplete($event)"></gb-event-ticket-purchase-guest>
        </mat-step>

        <mat-step
          [label]="'EVENT_TICKET_PACKAGES.PURCHASE.STEP_LABEL_PURCHASE' | translate"
          [editable]="false"
          aria-label="Payment"
        >
          @if (obs.selectedStepIndex === 1) {
            @if (isFreeTicket$ | async) {
              <div class="free-ticket-container">
                <p
                  [innerHTML]="
                    'EVENT_TICKET_PACKAGES.PURCHASE.PURCHASING_FOR'
                      | translate: { name: selectedProfile | gbDisplayName }
                  "
                ></p>
                <div class="ticket-quantity-container">
                  <gb-form-field
                    [control]="ticketForm.get('quantity')"
                    type="number"
                    labelTranslateKey="EVENT_TICKET_PACKAGES.PURCHASE.QUANTITY"
                    focusInput
                  ></gb-form-field>
                </div>

                <button
                  class="free-confirm-btn"
                  mat-flat-button
                  type="button"
                  (click)="placeEventTicketPurchase()"
                  [disabled]="(placePurchaseLoaded$ | async) === false"
                >
                  <gb-button-loader [loaded$]="placePurchaseLoaded$">
                    <span translate="EVENT_TICKET_PACKAGES.PURCHASE.COMPLETE_PURCHASE"></span>
                  </gb-button-loader>
                </button>
              </div>
            } @else if (calculation$ | async; as calc) {
              <gb-payment-summary
                [paymentForm]="ticketForm"
                [amountValue]="calc.amountValue"
                [tax]="tax$ | async"
                [totalFee]="calc.totalFee"
                [totalAmountToPay]="calc.totalAmountToPay"
                [buttonLoaded]="(placePurchaseLoaded$ | async) ?? true"
                [quantity]="ticketForm.get('quantity')?.value"
                [requestInvoiceAllowed]="(selectedEventTicketPackage$ | async)?.request_invoice_allowed"
                (paymentMethodChange)="onPaymentMethodChange($event)"
                (formSubmitted)="placeEventTicketPurchase()"
              >
                <ng-template #topSectionTemplate let-form>
                  <span
                    [innerHTML]="
                      'EVENT_TICKET_PACKAGES.PURCHASE.PURCHASING_FOR'
                        | translate: { name: selectedProfile | gbDisplayName }
                    "
                  ></span>

                  <div class="ticket-quantity-container">
                    <gb-form-field
                      [control]="form.get('quantity')"
                      type="number"
                      labelTranslateKey="EVENT_TICKET_PACKAGES.PURCHASE.QUANTITY"
                      focusInput
                    ></gb-form-field>
                  </div>
                </ng-template>
              </gb-payment-summary>
            }
          }
        </mat-step>

        @if (selectedPaymentProcess === PaymentProcessEnum.Stripe) {
          <mat-step
            [label]="'EVENT_TICKET_PACKAGES.PURCHASE.STEP_LABEL_CONFIRM_PAYMENT' | translate"
            [editable]="false"
            aria-label="Payment"
          >
            @if (obs.selectedStepIndex === 2) {
              <gb-payment-confirm
                [totalAmount]="(calculation$ | async)?.totalAmountToPay ?? 0"
                [buttonLoaded]="(buttonLoaded$ | async) ?? true"
                (executePayment)="onConfirmStripePayment($event)"
                (paymentSessionExpired)="onPaymentSessionExpired()"
              >
                <ng-template #participantLabelTemplate>
                  <span
                    [innerHTML]="
                      'EVENT_TICKET_PACKAGES.PURCHASE.PURCHASING_FOR'
                        | translate: { name: selectedProfile | gbDisplayName }
                    "
                  ></span>
                </ng-template>
              </gb-payment-confirm>
            }
          </mat-step>
        }

        @if (selectedPaymentProcess !== PaymentProcessEnum.RequestInvoice) {
          <mat-step
            [label]="'EVENT_TICKET_PACKAGES.PURCHASE.STEP_LABEL_ASSIGN' | translate"
            [editable]="false"
            aria-label="Assign"
          >
            @let assignStepIndex = selectedPaymentProcess === PaymentProcessEnum.Stripe ? 3 : 2;
            @if (obs.selectedStepIndex === assignStepIndex) {
              <gb-event-ticket-multi-assign></gb-event-ticket-multi-assign>
            }
          </mat-step>
        }
      </mat-stepper>
    </div>
  }
}
